import { Routes } from '@angular/router';
import {FormComponent} from './form/form.component';
import {OverlayComponent} from './overlay/overlay.component';
import {RedirectComponent} from './redirect/redirect.component';

export const routes: Routes = [
  {
    path: 'form',
    component: FormComponent
  },
  {
    path: 'redirect',
    component: RedirectComponent
  },
  {
    path: '**',
    component: OverlayComponent
  }
];
